<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.STATIC_PAGE'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.STATIC_PAGES'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <!-- <a href="javascript:void(0)" class="btn custom-btn brand-btn" routerLink="add">
                           <span [translate]="'GREATER.LOW'"> </span>
                        </a>                  -->
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
             
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-2" ><span [translate]="'GREATER.STATIC_PAGE'"> </span></h5>
                            </div>
                            <hr>
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.DESCRIPTION'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing ; let i = index ">
                                        <td scope="row">{{ i + 1 }}</td>
                                        <td>{{item.title}}</td>
                                        <td [innerHtml]="item.description | truncate:150"></td>
                                        <td>
                                            <span class="badge bg-success" *ngIf="item.status == 'Active'">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status == 'Deactive'">Danger</span>
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info text-center" (click)="redirect(item)">
                                                    <i class="bx bx-pencil"></i>
                                                </button>
                                                <!-- <button type="button" class="btn btn-danger text-center" (click)="redirect(item)">
                                                    <i class="bx bx-trash"></i>
                                                </button> -->
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>